import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapDispatchToProps from './command.tsx';
import mapStateToProps from './query.tsx';
import View from './view.tsx';

export default connect(mapStateToProps, mapDispatchToProps)(View);

// remove when cleaning entrypoint_migration_arj-description-editor
